<template>
  <section
    v-if="projectLanguages?.length > 0"
    :class="{
      '--large': mobileBreakPoint == 'lg', 
      '--medium': mobileBreakPoint == 'md'
    }" 
    class="gf-search-filter-project-language"
  >
    <div
      class="gf-search-filter-project-language__header"
      v-if="showHeader"
    >
      <b class="title">{{ $t('message.language') }}</b>
      <router-link
        v-if="$route.query?.language?.length > 0"
        class="reset-button btn btn-sm"
        active-class=""
        exact-active-class=""
        tag="button"
        :to="{ query: { ...$route.query, language: undefined, page: 0 } }"
      >
        Сбросить
      </router-link>
    </div>
    <div class="gf-search-filter-project-language__list">
      <router-link
        v-for="(projectLanguage, index) in languages"
        :key="index"
        class="gf-search-filter-project-language__item"
        :class="{ '--active': $route.query?.language === projectLanguage.alias }"
        active-class=""
        exact-active-class=""
        tag="a"
        :to="{ query: { ...$route.query, language: projectLanguage.alias, page: 0 } }"
      >
        <span
          class="repo-language-color mr-1"
          :class="`lang-color-${formatLanguageColorClass(projectLanguage?.alias)}`"
        ></span>
        <span class="language-title">{{ projectLanguage?.title }}</span>
        <router-link
          class="reset-language btn"
          type="button"
          active-class=""
          exact-active-class=""
          tag="button"
          :to="{ query: { ...$route.query, language: undefined, page: 0 } }"
        >
          <i class="gf-icon gf-icon-x"></i>
        </router-link>
      </router-link>
      <button
        class="show-more btn btn-sm"
        v-if="isTooBigList && showShortList"
        @click="$emit('showMore')"
      >
        Еще
      </button>
    </div>
  </section>
</template>

<script>
export default {
  name: 'GfSearchFilterProjectLanguage',
  props: {
    showShortList: {
      type: Boolean,
      default: false
    },
    showHeader: {
      type: Boolean,
      default: true
    },
    mobileBreakPoint: {
      type: String, 
      // props принимает брейк-поинт lg, md. 
      // Можно также дописать под все брейк-поинт в файле theme.scss
      default: 'md'
    }
  },
  computed: {
    projectLanguages() {
      return this.$store.getters.getSearchProjectLanguages || [];
    },
    isTooBigList() {
      return this.projectLanguages?.length > 5;
    },
    languages() {
      return this.showShortList && this.isTooBigList
        ? this.projectLanguages.slice(0, 5)
        : this.projectLanguages;
    }
  },
  methods: {
    formatLanguageColorClass(languageName) {
      return languageName
        ?.toLowerCase()
        .replaceAll('#', 'sharp')
        .replaceAll('.', '-')
        .replaceAll('+', 'plus')
        .replaceAll(' ', '-');
    }
  }
};
</script>

<style lang="scss">
$this: '.gf-search-filter-project-language';

#{$this} {
  &.--medium {
    width: 100%;
    padding: 14px;
    display: flex;
    flex-direction: column;
    gap: 8px;
    background-color: var(--light);
    border: 1px solid var(--border-color);
    border-radius: 6px;

    @include theme.md {
      width: 300px;
    }

    #{$this}__header {
      min-height: 30px;
      display: flex;
      align-items: center;
      gap: 8px;

      & .title {
        font-size: 16px;

        @include theme.md {
          font-size: 14px;
        }
      }

      & .reset-button {
        margin-left: auto;
        color: var(--text-muted);
      }
    }

    #{$this}__list {
      display: flex;
      flex-direction: column;
      gap: 8px;

      @include theme.md {
        max-height: 300px;
        overflow: auto;
      }

      #{$this}__item {
        min-height: 38px;
        padding: 6px;
        border-radius: 4px;
        display: flex;
        align-items: center;
        gap: 8px;

        @include theme.md {
          min-height: 32px;
        }

        & > .language-title {
          color: var(--text);
        }

        & > .reset-language {
          margin-left: auto;
          padding: 0;
          display: none !important;
          color: var(--text-muted);

          &:hover {
            color: var(--text);
          }

          & > i {
            font-size: 20px !important;

            @include theme.md {
              font-size: 16px !important;
            }
          }
        }

        &.--active {
          background-color: var(--bg-light);

          & > .reset-language {
            display: flex !important;
          }
        }

        &:hover {
          background-color: var(--bg-light);
        }
      }

      & .show-more {
        padding: 10px;
        background-color: var(--bg-light);
      }
    }
  }

  &.--large {
    width: 100%;
    padding: 14px;
    display: flex;
    flex-direction: column;
    gap: 8px;
    background-color: var(--light);
    border: 1px solid var(--border-color);
    border-radius: 6px;

    @include theme.lg {
      width: 300px;
    }

    #{$this}__header {
      min-height: 30px;
      display: flex;
      align-items: center;
      gap: 8px;

      & .title {
        font-size: 16px;

        @include theme.lg {
          font-size: 14px;
        }
      }

      & .reset-button {
        margin-left: auto;
        color: var(--text-muted);
      }
    }

    #{$this}__list {
      display: flex;
      flex-direction: column;
      gap: 8px;

      @include theme.lg {
        max-height: 300px;
        overflow: auto;
      }

      #{$this}__item {
        min-height: 38px;
        padding: 6px;
        border-radius: 4px;
        display: flex;
        align-items: center;
        gap: 8px;

        @include theme.lg {
          min-height: 32px;
        }

        & > .language-title {
          color: var(--text);
        }

        & > .reset-language {
          margin-left: auto;
          padding: 0;
          display: none !important;
          color: var(--text-muted);

          &:hover {
            color: var(--text);
          }

          & > i {
            font-size: 20px !important;

            @include theme.lg {
              font-size: 16px !important;
            }
          }
        }

        &.--active {
          background-color: var(--bg-light);

          & > .reset-language {
            display: flex !important;
          }
        }

        &:hover {
          background-color: var(--bg-light);
        }
      }

      & .show-more {
        padding: 10px;
        background-color: var(--bg-light);
      }
    }
  }
}
</style>
